import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import connect from 'components/lib/connect';
import CustomerWasCombined from 'components/customer/customer_was_combined';
import ExternalCustomerLookupSearch from './external_customer_lookup_search';
import { ExternalCustomerLookupStatusValue } from 'models/external_customer_lookup_status';
import LoadingSpinner from 'components/lib/loading_spinner';
import NavigateBack from 'actions/current_location/navigate_back';

const ExternalCustomerLookupContainer = connect(mapStateToProps, mapExecuteToProps)(ExternalCustomerLookup);

ExternalCustomerLookupContainer.propTypes = {
  customerId: PropTypes.string.isRequired,
};

export default ExternalCustomerLookupContainer;

function mapStateToProps({ getProvider }, { customerId }) {
  const customerMerge = getProvider('customerMerge').get();
  const mergedCustomerId =
    customerMerge && _.get(customerMerge, 'sourceCustomerId') === customerId && _.get(customerMerge, 'destCustomerId');

  const customerProfileDefProvider = getProvider('customerProfileDef');
  const lookupStatusProvider = getProvider('externalCustomerLookupStatus');

  const profileProvider = getProvider('profile');

  const isLoading =
    profileProvider.isLoading() || customerProfileDefProvider.isLoading() || lookupStatusProvider.isLoading();
  const isLookupEnabled =
    _.get(getProvider('externalCustomerLookupStatus').get(), 'status') === ExternalCustomerLookupStatusValue.OK;
  const isBasicDisabled = _.get(getProvider('externalCustomerLookupStatus').get(), 'basicDisabled');

  const profile = profileProvider.get();

  return {
    isBasicDisabled,
    isLoading,
    isLookupEnabled,
    mergedCustomerId,
    profile,
  };
}

function mapExecuteToProps(executeAction) {
  return {
    onClickBack: () => executeAction(NavigateBack),
  };
}

export function ExternalCustomerLookup({
  isBasicDisabled,
  isLoading,
  isLookupEnabled,
  profile,
  onClickBack,
  mergedCustomerId,
}) {
  if (mergedCustomerId) {
    return <CustomerWasCombined customerId={mergedCustomerId} />;
  }

  if (isLoading) {
    return <LoadingSpinner />;
  } else if (!isLookupEnabled || isBasicDisabled) {
    let errorMessage = !isLookupEnabled ? 'Customer lookup is not enabled.' : 'Basic lookup is not enabled.';
    return (
      <div className="externalCustomerLookup-alreadyLinked">
        <div>{errorMessage}</div>
        <div className="externalCustomerLookup-alreadyLinked-link" onClick={onClickBack}>
          Click to go back
        </div>
      </div>
    );
  }

  if (!profile) {
    return null;
  }

  return <ExternalCustomerLookupSearch profile={profile} />;
}

ExternalCustomerLookup.propTypes = {
  isBasicDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  isLookupEnabled: PropTypes.bool,
  mergedCustomerId: PropTypes.string,
  onClickBack: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/external_customer_lookup/external_customer_lookup.jsx